import React, { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import {
  CambiarEstadoRevision,
  getProveedorId,
} from "../../API/Proveedores/ProveedoresRequest";
import { getEstadosCategoryIPS } from "../../API/Global/Estados/StatusRequest";
import { Button } from "primereact/button";
import { toastShow } from "../../Services/ToastService";
import { Toast } from "primereact/toast";
import { AuthContext } from "../../Context/AuthContext/AuthContext";
import { InputText } from "primereact/inputtext";
import { useForm } from "../../Hooks/useForm";
import { getDateTimeStringSQL24 } from "../../Services/Moment/Luxon";

const DialogEstadoRevision = ({ visible, setVisible, informacion, userAuth, getCompanyInfo, Token }) => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [estadosRevision, setEstadosRevision] = useState([]);
  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm({
    IdStatusRevision: null,
    IdUserRevisoFinanzas: null,
    FechaRevisadoFinanzas: null,
    ComentarioRevisadoFinanzas: null,
    IdUsuarioRevision: null,
    DateRevision: null,
    ComentarioRevisadoCompras: null
  })
  const [selectedEstado, setSelectedEstado] = useState(null);

  const getInfo = async () => {
    setLoading(true);
    const info = await getProveedorId(informacion?.IdCustomer);
    setData(info[0]);
    let tempoValues = { ...info[0] }
    setValues(tempoValues)
    const tempoEstadosRevision = await getEstadosCategoryIPS("Revision Proveedor");
    let estadosFiltrados = tempoEstadosRevision
    if (userAuth?.IdRol !== 1) {
      if ([1047, 8].includes(userAuth?.IdRol)) {
        estadosFiltrados = tempoEstadosRevision?.filter((s) => s.IdStatus === 3724);
      }
      if ([17].includes(userAuth?.IdRol)) {
        estadosFiltrados = tempoEstadosRevision?.filter((s) => s.IdStatus === 3725);
      }
    }


    setEstadosRevision(estadosFiltrados);
    setLoading(false);
  };

  const hideDialog = () => {
    setVisible(false);
    setSelectedEstado(null);
  };

  const handleCheckboxChange = (estadoId) => {
    let tempoValues = { ...values }
    tempoValues.IdStatusRevision = estadoId
    // setValues
    // setSelectedEstado((prev) => (prev === estadoId ? null : estadoId));
  };

  const cambiarEstado = async () => {
    if (!values.IdStatusRevision) {
      toastShow(toast, "warn", "Requerido", "Debe seleccionar el estado");
      return;
    }
    let datosEnviar = {
      ...values,
      IdCustomer: data?.IdCustomer,
      IdUserRevisoFinanzas: values.IdStatusRevision === 3724 ? data?.IdUserRevisoFinanzas : userAuth?.idUser,
      IdUsuarioRevision: values.IdStatusRevision === 3724 ? userAuth?.idUser : data?.IdUsuarioRevision,
      FechaRevisadoFinanzas: values.IdStatusRevision === 3725 ? getDateTimeStringSQL24(new Date()) : data?.FechaRevisadoFinanzas,
      DateRevision: values.IdStatusRevision === 3724 ? getDateTimeStringSQL24(new Date()) : data?.DateRevision,
      Token: Token,
    }

    setLoading(true);
    const result = await CambiarEstadoRevision(datosEnviar);
    if (result?.length > 0) {
      if (result[0]?.ERROR === 0) {
        toastShow(toast, 'success', result[0]?.MSJ)
      } else {
        toastShow(toast, 'error', result[0]?.MSJ)
      }
    } else {
      toastShow(toast, 'error', 'Ocurrio un error al cambiar el estado de la revisión')
    }


    setTimeout(() => {
      hideDialog();
      setLoading(false);
    }, 1500);
  };

  const DialogFooter = (
    <React.Fragment>
      <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
      <Button label="Aceptar" icon="pi pi-check" className="p-button-text" onClick={() => cambiarEstado()} loading={loading} />
    </React.Fragment>
  );

  useEffect(() => {
    if (visible) {
      getInfo();
    } else {
      resetForm({})
    }
  }, [visible]);

  return (
    <Dialog header={`Cambiar Estado Revisión a ${data?.CustomerName || "Proveedor"}`} visible={visible}
      style={{ width: "40vw" }} onHide={hideDialog} footer={DialogFooter}
    >
      <Toast ref={toast} />
      <div className="px-4">
        <p>
          Al cambiar el estado de revisión del proveedor, usted confirma que ha
          revisado y validado toda la información correspondiente.
        </p>

        {estadosRevision?.map((estado) => (
          <div key={estado.Id} className="field-checkbox gap-2">
            <Checkbox
              inputId={`estado_${estado?.IdStatus}`}
              checked={estado?.IdStatus === values.IdStatusRevision}
              onChange={(e) => {
                handleChange((e.checked ? estado?.IdStatus : null), 'IdStatusRevision')

              }
                // handleCheckboxChange(estado.IdStatus)
              }
            />
            <label htmlFor={`estado_${estado.IdStatus}`} className="ml-2" style={{ fontWeight: 600 }}>
              {estado.StatusName}
            </label>
          </div>
        ))}
        <div className="pt-2" style={{ width: '100%' }}>
          {[1, 1047, 8].includes(userAuth?.IdRol) ?
            <span className="p-float-label " >
              <InputText
                value={values.ComentarioRevisadoCompras}
                onChange={(e) => handleInputChange(e, 'ComentarioRevisadoCompras')}
                style={{ width: '100%' }}
                disabled={values.IdStatusRevision !== 3724}
              />
              <label>Comentario Revisado Compras</label>
            </span>
            : null
          }
          {[1, 17].includes(userAuth?.IdRol) ?
            <span className="p-float-label pt-4 " style={{ width: '100%' }}>
              <InputText
                value={values.ComentarioRevisadoFinanzas}
                onChange={(e) => handleInputChange(e, 'ComentarioRevisadoFinanzas')}
                style={{ width: '100%' }}
                disabled={values.IdStatusRevision !== 3725}
              />
              <label>Comentario Revisado Finanzas</label>
            </span>
            : null
          }
        </div>

      </div>
    </Dialog>
  );
};

export default DialogEstadoRevision;
